module.exports = __webpack_public_path__ + "static/media/slide-3.6fa48357.png";